// extracted by mini-css-extract-plugin
export default {"rpBasicInfoRoot":"resourceParents_rpBasicInfoRoot__BS6s5","rpRouteContainer":"resourceParents_rpRouteContainer__MjGR1","rpRouteContent":"resourceParents_rpRouteContent__oPC0P"};